import { createContext } from 'preact';
import { useContext } from 'preact/hooks';
import type { Player } from '@schibsted-svp/web-player';

const PlayerContext = createContext<Player>(undefined!);

export const PlayerProvider = PlayerContext.Provider;

export function usePlayer() {
  return useContext(PlayerContext);
}
